(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.imageGalItem = {
    attach: function (context) {


      //Adding automatics numbers to group gallerys and panels
      $('.gallery__item .gallery__item-trigger').each(function (i) {
        var a = '#gallery__item-' + (i++);
        $(this).attr('data-src', a);
      });

      $('.gallery__item .gallery__item-modal').each(function (i) {
        var b = 'gallery__item-' + (i++);
        $(this).attr('id', b);
      });

      //Image Gallery - Fancybox
      $('[data-fancybox="gallery"]').fancybox({
        toolbar: false,
        btnTpl: {
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            '<span class="icon-times-circle-o"></span>' +
            "</button>",
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<span class="icon-arrow-circle-left"></span>' +
            "</button>",
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<span class="icon-arrow-circle-right"></span>' +
            "</button>",
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
            '<span class="icon-times-circle-o"></span>' +
            "</button>"
        },
      });


    },
  };
})(jQuery, Drupal);
